// TODO: upgrade to RHF
/**
 * Сформировать перечень ошибок валидации
 *
 * @param {?Array} prevState
 * @param {?String} currentState
 * @param {?|Object|Array<Object>} refInputList
 * @param {Boolean} isVisibleError
 * @return {Array}
 */
export default function combineErrorList(prevState, currentState, refInputList, isVisibleError) {
  const errorList = [];
  const index = prevState?.findIndex(item => item === currentState);

  if (isVisibleError) {
    changeInputListColor(refInputList, true);

    if (prevState?.includes(currentState)) {
      return prevState;
    }

    errorList.push(...prevState, currentState);
  }

  if (!isVisibleError) {
    changeInputListColor(refInputList, false);

    if (index !== -1) {
      prevState.splice(index, 1);
      return prevState;
    }

    return prevState;
  }

  return errorList;
}

/**
 * Изменить бордер у элемента управления на форме
 *
 * @param {Array} refInputList
 * @param {Boolean} isVisibleError
 */
const changeInputListColor = (refInputList, isVisibleError) => {
  const fnAdd = (element = refInputList[0]) => element?.classList?.add("input--invalid");
  const fnRemove = (element = refInputList[0]) => element?.classList?.remove("input--invalid");

  const fn = isVisibleError ? fnAdd : fnRemove;
  refInputList?.forEach(input => fn(input?.current || input));
};
